import { gql } from '@apollo/client'
import { AUDIT_QUESTION_FRAGMENT } from '../fragments'

export const CREATE_AUDIT_QUESTION = gql`
  mutation CreateAuditQuestion($input: CreateAuditQuestionInput!) {
    createAuditQuestion(input: $input) {
      auditQuestion {
        ...AuditQuestion
      }
    }
  }
  ${AUDIT_QUESTION_FRAGMENT}
`
